import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICountry, ILocationsState, IState } from "../@types/locations";

const initialState: ILocationsState = {
  countries: [],
  states: [],
  loading: false,
};

const locations = createSlice({
  name: "locations",
  initialState,
  reducers: {
    setCountries: (state, action: PayloadAction<ICountry[]>) => {
      state.countries = action.payload;
    },
    setStates: (state, action: PayloadAction<IState[]>) => {
      state.states = action.payload;
    },
    clearStates: (state) => {
      state.states = [];
    },
    setLocationsLoading: (state) => {
      state.loading = true;
    },
    disableLocationsLoading: (state) => {
      state.loading = false;
    },
  },
});

export const {
  setCountries,
  setStates,
  clearStates,
  setLocationsLoading,
  disableLocationsLoading,
} = locations.actions;

export default locations.reducer;
